import React, { useEffect, useState } from "react";
import { useParams, useNavigate  } from "react-router-dom";
import {
  Button,
  Modal,
  Form,
  Col,
  Row
} from "react-bootstrap";
import Agree from "./Agree"; // adjust path if necessary


export default function Sign(props) {
  const { id } = useParams();
  const navigate = useNavigate ();

  const [show, setShow] = useState(true);
  const [isChecked, setIsChecked] = useState(false);
  const [signName, setSignName] = useState({ name: '', initials: '' });
  const [allowAdopt, setAllowAdopt] = useState(false);

  /* --- ROUTING GUARD ---------------------------------------------------- */
  useEffect(() => {
    if (props.stat === 'Cancelled') navigate(`/${id}/expired`);
  }, [props.stat, navigate, id]);

  /* --- ENABLE / DISABLE BUTTON ------------------------------------------ */
  useEffect(() => {
    const enabled =
      signName.name.trim() !== '' &&
      signName.initials.trim() !== '' &&
      isChecked;
    setAllowAdopt(enabled);
  }, [signName, isChecked]);

  /* ------------ HANDLERS ------------------------------------------------ */
  const handleCheck = (e) => setIsChecked(e.target.checked);

  const handleInput = (e) =>
    setSignName((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const adopt = () => {
    props.sign(signName);
     props.setsign(signName);
    setShow(false);
    // console.log("Signature adopted:", signName);
  };

  /* ------------ JSX ----------------------------------------------------- */
  return (

    <>
     {signName.name.trim() === '' && (
    <Button variant="primary" onClick={() => setShow(true)}>
      Adopt Signature
    </Button>
  )}
  

    <Modal show={show} onHide={() => setShow(false)} backdrop="static">
      <Modal.Header closeButton><Modal.Title>Set Signature</Modal.Title></Modal.Header>

      <Modal.Body>
        <Form>
          <Row className="align-items-center">
            <Col>
              <Form.Group controlId="formBasicName">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Enter Name"
                  value={signName.name}
                  onChange={handleInput}
                  autoComplete="off"
                />
              </Form.Group>
            </Col>

            <Col sm={3}>
              <Form.Group controlId="formBasicInitial">
                <Form.Label>Initials</Form.Label>
                <Form.Control
                  type="text"
                  name="initials"
                  placeholder="Initials"
                  value={signName.initials}
                  onChange={handleInput}
                  autoComplete="off"
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>

        <Row className="align-items-center mt-3">
          <Col><div className="sig3">{signName.name}</div></Col>
          <Col sm={3}><div className="sig3">{signName.initials}</div></Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <Form className="me-auto">
          <Form.Check
            inline
            id="agree-check"
            label={<Agree />}
            checked={isChecked}
            onChange={handleCheck}
          />
        </Form>

        <Button variant="secondary" onClick={() => setShow(false)}>
          Close
        </Button>
        <Button variant="primary" onClick={adopt} disabled={!allowAdopt}>
          Adopt
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  );
}
